import React from 'react';
import {FormattedMessage} from 'react-intl';
import EmployeeName from './EmployeeName';
import ManagerAvatars from 'main/containers/performance_reviews/components/reviews/components/manage/components/reviewees/components/ManagerAvatars';
import ReviewerAvatars from 'main/containers/performance_reviews/components/reviews/components/manage/components/reviewees/components/ReviewerAvatars';
import SharedWithReviewee from './SharedWithReviewee';

export const MANAGER_REVIEW_COLUMNS = [
  {
    header: 'performance_reviews.view.Reviewee',
    width: 3,
    component: EmployeeName,
    sticky: true
  },
  {
    header: 'performance_reviews.manage.Managers',
    width: 2,
    component: ManagerAvatars
  },
  {
    header: 'performance_reviews.manage.Reviewers',
    width: 2,
    component: ReviewerAvatars
  },
  {
    header: 'performance_reviews.manage.Due Date',
    width: 2,
    render: model => model.dueDateView
  },
  {
    header: 'performance_reviews.manage.Launch Date',
    width: 2,
    render: model => model.launchDateView
  },
  {
    header: 'performance_reviews.view.Status',
    width: 2,
    render: model => <FormattedMessage id='performance_reviews.view.REVIEWS_RECEIVED'
      values={{received: model.completedReviews, total: model.totalReviews}}/>
  },
  {
    header: 'performance_reviews.view.Shared With Reviewee',
    width: 2.5,
    component: SharedWithReviewee
  }
];

export const NON_MANAGER_REVIEW_COLUMNS = [
  {
    header: 'performance_reviews.view.Reviewee',
    width: 3,
    component: EmployeeName,
    sticky: true
  },
  {
    header: 'performance_reviews.manage.Managers',
    width: 2,
    component: ManagerAvatars
  },
  {
    header: 'performance_reviews.manage.Reviewers',
    width: 2,
    component: ReviewerAvatars
  },
  {
    header: 'performance_reviews.manage.Due Date',
    width: 2,
    render: model => model.dueDateView
  },
  {
    header: 'performance_reviews.manage.Launch Date',
    width: 2,
    render: model => model.launchDateView
  },
  {
    header: 'performance_reviews.view.Status',
    width: 3,
    render: model => <FormattedMessage id='performance_reviews.view.REVIEWS_RECEIVED'
      values={{received: model.completedReviews, total: model.totalReviews}}/>
  }
];
